import './SettingsIcon.css'
export default function SettingsIcon(){
    return <div className="settings"></div>
}